// src/context/ConfigContext.tsx
import React, { createContext, useContext } from "react";
import { useConfigData } from "../hooks/useConfigData";
import type { configurationData, errorData } from "../types";

interface ConfigContextType {
  configData: configurationData | null;
  error: errorData | null;
  configReady: boolean | false,
}

const ConfigContext = createContext<ConfigContextType>({
  configData: null,
  error: null,
  configReady: false,
});

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { configData, error, configReady } = useConfigData(); // fetch once here
  
  return (
    <ConfigContext.Provider value={{ configData, error, configReady }}>
      {children}
    </ConfigContext.Provider>
  );
};

// Custom hook for easy usage
export function useConfig() {
  return useContext(ConfigContext);
}
